import './featuredPublication.css'
import publicationImage from "../../assets/images/integrated-behavioral-health-book.jpeg";

const FeaturedPublication = () => {

    return (
        <section id='featured-publication' className='featured-publication'>
            <div className='featured-publication-container'>
                <div className='featured-publication-image-wrap'>
                    <img
                        className='featured-publication-image'
                        src={publicationImage}
                        alt='Integrated Behavioral Health: Applying the Biodyne Model in Healthcare'
                    />
                </div>
                <div className='featured-publication-copy'>
                    <div className='featured-publication-kicker'>Now Available</div>
                    <h2 className='featured-publication-title'>
                        Featured Chapter on Trauma-Informed Integrated Care
                    </h2>
                    <p className='featured-publication-chapter'>
                        Chapter 9: "The Trauma Connection: What Every Integrated Care Provider Needs to Know"
                    </p>
                    <p className='featured-publication-body'>
                        Trauma is not the exception in patient populations, it is the norm. Its unaddressed weight
                        drives soaring healthcare costs, worsening outcomes and provider burnout. For clinicians
                        committed to health optimization, understanding trauma is the missing cornerstone.
                    </p>
                    <div className='featured-publication-author'>
                        <div>Dr. Gayle Cordes</div>
                        <div>Lead Author</div>
                    </div>
                    <a
                        href='https://www.taylorfrancis.com/reader/read-online/5b6ea41f-91a0-4b85-b0ff-698b8aeb6753/chapter/pdf?context=ubx'
                        target='_blank'
                        rel='noreferrer'
                    >
                        <button className='featured-publication-button'>
                            Read Open Access Chapter
                        </button>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default FeaturedPublication;
